<template>
  <div class="activeInf w1400">
    <div class="activeInf-title font20">
      当前位置： {{ pageName.ts002 }} > 信息详情
    </div>
    <div class="activeInf-cont">
      <h1>{{ newInf.ty002 }}</h1>
      <div class="author">来源：{{ newInf.ty012?newInf.ty012:'' }}<span class="line-pad">|</span>作者： {{ newInf.ty011?newInf.ty011:'' }}  <span class="line-pad">|</span>发布日期： {{newInf.createdt | formatTime}}</div>
      <div id="newsAbout"></div>
      <div v-for="(item,i) in newInf.ty010" :key='i' class="tb13 font16">
        <a :href="item.url">{{ '附件' + (i + 1) + ': ' + item.name }}</a>
      </div>
      <img src="../../assets/skeleton.png" alt="" v-if="!newInf.ty005">
    </div>
  </div>
</template>

<script>
import bus from '../../public/bus.js'

export default {
  data() {
    return {
      newsId: null,
      newInf: {},
      pageName: ''
    }
  },
  created() {
    this.newsId = this.$route.query.newsId || this.$route.params.newsId;
    this.pageName = this.$route.query.pageId || this.$route.params.pageId;
    this.getNewsInfo();
    bus.$emit('catchTab', this.$route.params.pageId);
  },
  methods: {
    getNewsInfo() {
      this.$axios.post("/api/news/getById", {
        quoteid: this.newsId
      }).then(res => {
        let response = res.data.data;
        response.ty010 = response.ty010 ? JSON.parse(response.ty010) : [];
        this.newInf = response;
        let data = response.ty005.replace(/192.168.81.240:8086/g, 'file.sywlfz.com')
        document.querySelector('#newsAbout').innerHTML = data;
        document.querySelectorAll('#newsAbout img').forEach(ele => {
          ele.style.display = 'block';
          ele.style.width = '90%';
          ele.style.margin = '0 auto';
        })
        document.querySelectorAll("pre").forEach(ele => {
          ele.style.whiteSpace = 'break-spaces';
        })
      })
    }
  }
}
</script>

<style scoped>
.activeInf-cont {
  width: 85%;
  margin: 0 auto;
}

.activeInf-title {
  box-sizing: border-box;
  height: 7rem;
  line-height: 7rem;
  padding-left: 2.7rem;
  background-color: #F6F5F5;
}

.author {
  padding: 10px 0 40px;
  border-top: 1px solid black;
  text-align: center;
  color: #9b9b9b;
}
.line-pad{
  padding: 0 20px;
}

.activeInf-cont > img {
  display: block;
  max-width: 80%;
  margin: 10px auto;
}

#newsAbout {
  text-indent: 4rem;
  font-size: 2rem;
  margin-bottom: 2.4rem;
}

pre {
  white-space: break-spaces;
}

.tb13 {
  margin-top: 1.3rem;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/activeInf.vue